import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=fc036cb0&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc036cb0')) {
      api.createRecord('fc036cb0', component.options)
    } else {
      api.reload('fc036cb0', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=fc036cb0&", function () {
      api.rerender('fc036cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24fXGZ4EUs7Gy/JS/CurrentYear.vue"
export default component.exports